export default __webpack_public_path__ + "static/culet-feeb0732b6b3b396f274c2b4659afdd9.png";